import { render, staticRenderFns } from "./BorrowReturnStatusCard.vue?vue&type=template&id=61f36956&scoped=true&"
import script from "./BorrowReturnStatusCard.vue?vue&type=script&lang=js&"
export * from "./BorrowReturnStatusCard.vue?vue&type=script&lang=js&"
import style0 from "./BorrowReturnStatusCard.vue?vue&type=style&index=0&id=61f36956&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61f36956",
  null
  
)

export default component.exports